const minLenthFields = document.querySelectorAll('[minlength]');

minLenthFields.forEach((field) => {
    if (field.getAttribute('aria-required') !== 'true') {
        return;
    }

    const parentLabel = field.closest('label');
    const wordCount = parentLabel.querySelector('.wordcount');
    const wordNumber = parentLabel.querySelector('.wordnumber');
    const minWords = field.getAttribute('minlength');
    if (wordCount) {
        wordCount.style.display = 'inline-block';
        wordCount.textContent = '0/' + minWords;
    }
    if (wordNumber) {
        wordNumber.textContent = minWords;
    }

    field.addEventListener('input', () => {
        // Conta le parole ignorando spazi multipli e linee vuote
        const text = field.value.trim();
        const words = text === '' ? [] : text.split(/\s+/);
        const count = words.length;

        wordCount.textContent = count + '/' + minWords;

        if (count >= minWords) {
            wordCount.style.color = 'var(--color-green-500)';
        } else if (count == 0) {
            wordCount.style.color = 'var(--color-black)';
        } else {
            wordCount.style.color = 'var(--color-red-500)';
        }
    });
});
